import { Link, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../proyectos.css";

const API_BASE = "https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default function Proyectos() {
  const location = useLocation();

  const [clientes, setClientes] = useState([]);
  const [cotizacionesCliente, setCotizacionesCliente] = useState([]);
  const [generadoresCliente, setGeneradoresCliente] = useState([]);
  const [proyectos, setProyectos] = useState([]);

  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroInicio, setFiltroInicio] = useState("");
  const [filtroFin, setFiltroFin] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [proyectoEditandoId, setProyectoEditandoId] = useState(null);

  const [clienteQuery, setClienteQuery] = useState("");
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [mostrarListaClientes, setMostrarListaClientes] = useState(false);

  const [nombre, setNombre] = useState("");
  const [documentoOrigenId, setDocumentoOrigenId] = useState("");
  const [ubicacion, setUbicacion] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [estatus, setEstatus] = useState("Pendiente");

  const [materialInput, setMaterialInput] = useState("");
  const [materiales, setMateriales] = useState([]);

  useEffect(() => {
    cargarClientes();
    cargarProyectos();
  }, []);

  const cargarClientes = async () => {
    try {
      const res = await api.get("/api/Clientes");
      setClientes(res.data || []);
    } catch (e) {
      console.error("Error clientes:", e);
    }
  };

  const cargarProyectos = async () => {
    try {
      const res = await api.get("/api/Proyectos");
      setProyectos(res.data || []);
    } catch (e) {
      console.error("Error proyectos:", e);
      console.error("Status:", e?.response?.status);
      console.error("Data:", e?.response?.data);
      setProyectos([]);
    }
  };

  const cargarCotizacionesPorCliente = async (clienteId) => {
    try {
      const res = await api.get(`/api/Cotizaciones?clienteId=${clienteId}`);
      setCotizacionesCliente(res.data || []);
    } catch (e) {
      console.error("Error cotizaciones por cliente:", e);
      setCotizacionesCliente([]);
    }
  };

  const cargarGeneradoresPorCliente = async (clienteId) => {
    try {
      const res = await api.get("/api/Generadores/buscar");

      const filtrados = (res.data || []).filter(
        (g) => Number(g.clienteID ?? g.ClienteID) === Number(clienteId)
      );

      setGeneradoresCliente(filtrados);
    } catch (e) {
      console.error("Error generadores por cliente:", e);
      setGeneradoresCliente([]);
    }
  };

  const formatearFechaInput = (fecha) => {
    if (!fecha) return "";
    return new Date(fecha).toISOString().split("T")[0];
  };

  const clientesFiltrados = useMemo(() => {
    const q = (clienteQuery || "").trim().toLowerCase();
    if (!q) return clientes;

    return (clientes || []).filter((c) => {
      const nombre = (c.nombre || c.Nombre || "").toLowerCase();
      const correo = (c.correo || c.Correo || "").toLowerCase();
      const tel = (c.telefono || c.Telefono || "").toLowerCase();

      return nombre.includes(q) || correo.includes(q) || tel.includes(q);
    });
  }, [clientes, clienteQuery]);

  const seleccionarCliente = async (c) => {
    const id = c.clienteID ?? c.ClienteID;
    const nombreCliente = c.nombre ?? c.Nombre;
    const correo = c.correo ?? c.Correo;
    const tel = c.telefono ?? c.Telefono;

    setClienteSeleccionado({
      id,
      nombre: nombreCliente,
      correo,
      tel,
    });

    setClienteQuery(nombreCliente || "");
    setMostrarListaClientes(false);
    setDocumentoOrigenId("");

    await cargarCotizacionesPorCliente(id);
    await cargarGeneradoresPorCliente(id);
  };

  const limpiarClienteSeleccionado = () => {
    setClienteSeleccionado(null);
    setClienteQuery("");
    setCotizacionesCliente([]);
    setGeneradoresCliente([]);
    setDocumentoOrigenId("");
  };

  const addMaterial = () => {
    const v = (materialInput || "").trim();

    if (!v) return;

    if (materiales.some((m) => m.toLowerCase() === v.toLowerCase())) {
      setMaterialInput("");
      return;
    }

    setMateriales([...materiales, v]);
    setMaterialInput("");
  };

  const removeMaterial = (idx) => {
    setMateriales(materiales.filter((_, i) => i !== idx));
  };

  const onMaterialKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addMaterial();
    }
  };

  const abrirModal = () => {
    setShowModal(true);
    setModoEdicion(false);
    setProyectoEditandoId(null);

    limpiarClienteSeleccionado();
    setNombre("");
    setUbicacion("");
    setFechaInicio("");
    setFechaFin("");
    setEstatus("Pendiente");
    setMaterialInput("");
    setMateriales([]);
  };

  const abrirModalEditar = async (p) => {
    const id = p.proyectoID ?? p.ProyectoID ?? p.id ?? p.Id;
    const clienteId = p.clienteID ?? p.ClienteID;
    const clienteNombre = p.clienteNombre ?? p.ClienteNombre ?? "";

    const cotId = p.cotizacionID ?? p.CotizacionID;
    const genId = p.generadorID ?? p.GeneradorID;

    setShowModal(true);
    setModoEdicion(true);
    setProyectoEditandoId(id);

    setClienteSeleccionado({
      id: clienteId,
      nombre: clienteNombre,
    });

    setClienteQuery(clienteNombre);
    setMostrarListaClientes(false);

    await cargarCotizacionesPorCliente(clienteId);
    await cargarGeneradoresPorCliente(clienteId);

    if (cotId) {
      setDocumentoOrigenId(`cot-${cotId}`);
    } else if (genId) {
      setDocumentoOrigenId(`gen-${genId}`);
    } else {
      setDocumentoOrigenId("");
    }

    setNombre(p.nombre ?? p.Nombre ?? "");
    setUbicacion(p.ubicacion ?? p.Ubicacion ?? "");
    setFechaInicio(formatearFechaInput(p.fechaInicio ?? p.FechaInicio));
    setFechaFin(formatearFechaInput(p.fechaFin ?? p.FechaFin));
    setEstatus(p.estatus ?? p.Estatus ?? "Pendiente");

    const mats = p.materiales ?? p.Materiales ?? [];
    setMateriales(Array.isArray(mats) ? mats : []);
    setMaterialInput("");
  };

  const cerrarModal = () => {
    setShowModal(false);
    setModoEdicion(false);
    setProyectoEditandoId(null);
  };

  const guardarProyecto = async () => {
    if (!clienteSeleccionado?.id) {
      alert("Selecciona un cliente.");
      return;
    }

    if (!nombre.trim()) {
      alert("Pon el nombre del proyecto.");
      return;
    }

    if (!documentoOrigenId) {
      alert("Selecciona una cotización o generador.");
      return;
    }

    if (!ubicacion.trim()) {
      alert("Pon la ubicación.");
      return;
    }

    if (!fechaInicio) {
      alert("Pon la fecha de inicio.");
      return;
    }

    const [tipoDocumento, idDocumento] = documentoOrigenId.split("-");

    const payload = {
      nombre: nombre.trim(),
      clienteId: Number(clienteSeleccionado.id),

      cotizacionId: tipoDocumento === "cot" ? Number(idDocumento) : null,
      generadorId: tipoDocumento === "gen" ? Number(idDocumento) : null,

      ubicacion: ubicacion.trim(),
      fechaInicio: fechaInicio,
      fechaFin: fechaFin || null,
      materiales: materiales,
      estatus: estatus,
    };

    try {
      if (modoEdicion) {
        await api.put(`/api/Proyectos/${proyectoEditandoId}`, payload);
        alert("Proyecto actualizado ✅");
      } else {
        await api.post("/api/Proyectos", payload);
        alert("Proyecto creado ✅");
      }

      cerrarModal();
      await cargarProyectos();
    } catch (e) {
      console.error("Error guardar proyecto:", e);
      console.error("Response status:", e?.response?.status);
      console.error("Response data:", e?.response?.data);

      const data = e?.response?.data;

      if (data?.errors) {
        const mensajes = Object.entries(data.errors)
          .map(([campo, errores]) => `${campo}: ${errores.join(", ")}`)
          .join("\n");

        alert(mensajes);
      } else {
        const msg =
          data?.title ||
          data?.message ||
          data ||
          "No se pudo guardar el proyecto.";

        alert(String(msg));
      }
    }
  };

  const actualizarEstatusProyecto = async (id, nuevoEstatus) => {
    try {
      await api.put(`/api/Proyectos/${id}`, {
        estatus: nuevoEstatus,
      });

      await cargarProyectos();
    } catch (e) {
      console.error("Error actualizando estatus:", e);
      alert("No se pudo actualizar el estatus.");
    }
  };

  const proyectosFiltrados = useMemo(() => {
    let list = [...(proyectos || [])];

    const q = filtroCliente.trim().toLowerCase();

    if (q) {
      list = list.filter((p) => {
        const cliente = (p.clienteNombre || p.ClienteNombre || "").toLowerCase();
        const nombreProyecto = (p.nombre || p.Nombre || "").toLowerCase();

        return cliente.includes(q) || nombreProyecto.includes(q);
      });
    }

    if (filtroInicio) {
      const d1 = new Date(filtroInicio);

      list = list.filter((p) => {
        const fi = p.fechaInicio || p.FechaInicio;
        if (!fi) return true;
        return new Date(fi) >= d1;
      });
    }

    if (filtroFin) {
      const d2 = new Date(filtroFin);

      list = list.filter((p) => {
        const ff = p.fechaFin || p.FechaFin;
        if (!ff) return true;
        return new Date(ff) <= d2;
      });
    }

    return list;
  }, [proyectos, filtroCliente, filtroInicio, filtroFin]);

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-title">RCI</div>

        <nav>
          <Link to="/dashboard" className={location.pathname === "/dashboard" ? "active" : ""}>
            Inicio
          </Link>

          <Link to="/cotizaciones" className={location.pathname.startsWith("/cotizaciones") ? "active" : ""}>
            Cotizaciones
          </Link>

          <Link to="/generadores" className={location.pathname.startsWith("/generadores") ? "active" : ""}>
            Generadores
          </Link>

          <Link to="/proyectos" className={location.pathname.startsWith("/proyectos") ? "active" : ""}>
            Proyectos
          </Link>

          <Link to="/clientes" className={location.pathname.startsWith("/clientes") ? "active" : ""}>
            Clientes
          </Link>
        </nav>
      </aside>

      <div className="main-area">
        <header className="header">Administrador de Proyectos</header>

        <main className="content">
          <h2>Proyectos</h2>

          <div className="proyectos-toolbar">
            <input
              type="text"
              placeholder="Buscar cliente o proyecto..."
              value={filtroCliente}
              onChange={(e) => setFiltroCliente(e.target.value)}
            />

            <input
              type="date"
              value={filtroInicio}
              onChange={(e) => setFiltroInicio(e.target.value)}
            />

            <input
              type="date"
              value={filtroFin}
              onChange={(e) => setFiltroFin(e.target.value)}
            />

            <button
              className="btn"
              onClick={() => {
                setFiltroCliente("");
                setFiltroInicio("");
                setFiltroFin("");
              }}
            >
              Limpiar
            </button>

            <button className="btn" onClick={abrirModal}>
              + Nuevo proyecto
            </button>
          </div>
        <div className="table-container">
          <table className="tabla-proyectos">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Cliente</th>
                <th>Documento</th>
                <th>Ubicación</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>Estatus</th>
                <th>Materiales</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {proyectosFiltrados.map((p) => {
                const id = p.proyectoID ?? p.ProyectoID ?? p.id ?? p.Id;
                const nombreProyecto = p.nombre ?? p.Nombre ?? "";
                const cliente = p.clienteNombre ?? p.ClienteNombre ?? "";

                const cotId = p.cotizacionID ?? p.CotizacionID;
                const genId = p.generadorID ?? p.GeneradorID;

                const documento = cotId
                  ? `Cotización #${cotId}`
                  : genId
                    ? `Generador #${genId}`
                    : "";

                const ub = p.ubicacion ?? p.Ubicacion ?? "";
                const fi = p.fechaInicio ?? p.FechaInicio;
                const ff = p.fechaFin ?? p.FechaFin;
                const est = p.estatus ?? p.Estatus ?? "Pendiente";
                const mats = p.materiales ?? p.Materiales ?? [];

                return (
                  <tr key={id}>
                    <td>{id}</td>
                    <td>{nombreProyecto}</td>
                    <td>{cliente}</td>
                    <td>{documento}</td>
                    <td>{ub}</td>
                    <td>{fi ? new Date(fi).toLocaleDateString() : ""}</td>
                    <td>{ff ? new Date(ff).toLocaleDateString() : ""}</td>

                    <td>
                      <select
                        value={est}
                        onChange={(e) => actualizarEstatusProyecto(id, e.target.value)}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="En progreso">En progreso</option>
                        <option value="Finalizado">Finalizado</option>
                      </select>
                    </td>

                    <td>
                      {Array.isArray(mats) && mats.length > 0 ? (
                        <div className="tags">
                          {mats.map((m, index) => (
                            <span key={index} className="tag">
                              {m}
                            </span>
                          ))}
                        </div>
                      ) : (
                        "Sin materiales"
                      )}
                    </td>

                    <td>
                      <button
                        className="btn btn-mini"
                        onClick={() => abrirModalEditar(p)}
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

          {showModal && (
            <div className="modal-backdrop" onMouseDown={cerrarModal}>
              <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
                <h3>{modoEdicion ? "Editar Proyecto" : "Nuevo Proyecto"}</h3>

                <label>Cliente</label>

                <div className="cliente-autocomplete">
                  <input
                    type="text"
                    placeholder="Escribe para buscar cliente..."
                    value={clienteQuery}
                    onChange={(e) => {
                      setClienteQuery(e.target.value);
                      setMostrarListaClientes(true);
                      setClienteSeleccionado(null);
                      setCotizacionesCliente([]);
                      setGeneradoresCliente([]);
                      setDocumentoOrigenId("");
                    }}
                    onFocus={() => setMostrarListaClientes(true)}
                  />

                  {clienteSeleccionado && (
                    <button
                      className="btn btn-sec btn-mini"
                      onClick={limpiarClienteSeleccionado}
                      type="button"
                    >
                      Cambiar
                    </button>
                  )}

                  {mostrarListaClientes &&
                    clientesFiltrados.length > 0 &&
                    !clienteSeleccionado && (
                      <div className="cliente-lista">
                        {clientesFiltrados.slice(0, 8).map((c) => {
                          const id = c.clienteID ?? c.ClienteID;
                          const nombreCliente = c.nombre ?? c.Nombre;
                          const correo = c.correo ?? c.Correo;
                          const tel = c.telefono ?? c.Telefono;

                          return (
                            <button
                              key={id}
                              className="cliente-item"
                              type="button"
                              onClick={() => seleccionarCliente(c)}
                            >
                              <div className="cliente-item-nombre">
                                {nombreCliente}
                              </div>

                              <div className="cliente-item-sub">
                                {(correo || "sin correo")} • {(tel || "sin RFC")}
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    )}
                </div>

                <label>Nombre del Proyecto</label>
                <input
                  type="text"
                  placeholder="Ej. Aeropuerto Hermosillo"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />

                <label>Documento origen</label>
                <select
                  value={documentoOrigenId}
                  onChange={(e) => setDocumentoOrigenId(e.target.value)}
                  disabled={!clienteSeleccionado}
                >
                  <option value="">
                    {clienteSeleccionado
                      ? "-- Selecciona cotización o generador --"
                      : "Primero selecciona cliente"}
                  </option>

                  {cotizacionesCliente.map((c) => {
                    const id = c.cotizacionID ?? c.CotizacionID;
                    const total = c.total ?? c.Total ?? 0;
                    const fecha = c.fecha ?? c.Fecha;
                    const ftxt = fecha ? new Date(fecha).toLocaleDateString() : "";

                    return (
                      <option key={`cot-${id}`} value={`cot-${id}`}>
                        Cotización #{id} • ${Number(total || 0).toFixed(2)} • {ftxt}
                      </option>
                    );
                  })}

                  {generadoresCliente.map((g) => {
                    const id = g.generadorID ?? g.GeneradorID;
                    const total = g.total ?? g.Total ?? 0;
                    const fecha = g.fecha ?? g.Fecha;
                    const ftxt = fecha ? new Date(fecha).toLocaleDateString() : "";

                    return (
                      <option key={`gen-${id}`} value={`gen-${id}`}>
                        Generador #{id} • ${Number(total || 0).toFixed(2)} • {ftxt}
                      </option>
                    );
                  })}
                </select>

                <label>Ubicación</label>
                <input
                  type="text"
                  placeholder="Ubicación del proyecto"
                  value={ubicacion}
                  onChange={(e) => setUbicacion(e.target.value)}
                />

                <div className="grid-2">
                  <div>
                    <label>Fecha Inicio</label>
                    <input
                      type="date"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </div>

                  <div>
                    <label>Fecha Fin (opcional)</label>
                    <input
                      type="date"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </div>
                </div>

                <label>Materiales</label>

                <div className="materiales-box">
                  <input
                    type="text"
                    placeholder="Ej: Pintura roja Berel... (Enter para agregar)"
                    value={materialInput}
                    onChange={(e) => setMaterialInput(e.target.value)}
                    onKeyDown={onMaterialKeyDown}
                  />

                  <button className="btn btn-mini" type="button" onClick={addMaterial}>
                    Agregar
                  </button>
                </div>

                {materiales.length > 0 && (
                  <div className="tags">
                    {materiales.map((m, idx) => (
                      <span key={idx} className="tag">
                        {m}
                        <button
                          type="button"
                          className="tag-x"
                          onClick={() => removeMaterial(idx)}
                        >
                          ✖
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                <label>Estatus</label>
                <select value={estatus} onChange={(e) => setEstatus(e.target.value)}>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En progreso">En progreso</option>
                  <option value="Finalizado">Finalizado</option>
                </select>

                <div className="acciones modal-acciones">
                  <button className="btn" onClick={guardarProyecto}>
                    {modoEdicion ? "Actualizar Proyecto" : "Crear Proyecto"}
                  </button>

                  <button className="btn btn-sec" onClick={cerrarModal}>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>

        <footer className="footer">© {new Date().getFullYear()} RCI</footer>
      </div>
    </div>
  );
}